import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, useMediaQuery } from "@mui/material";
import Button from "@/components/button";
import StorePicker from "../Components/StorePicker";
import ProductPicker from "../Components/ProductPicker";
import AddSalesModal from "@/modals/addSalesModal";
import CustomizedSnackbars from "@/components/snackBar";
import ChartLayout from "./ChartLayout";
import TableLayout from "./TableLayout";
import SwitchButtons from "./SwitchButtons";
import DateRangePicker from "../Components/DateRangePicker";

import { selectStores, selectStockTypes } from "@/store/store/selectors";

import useStyles from "./styles";
import { isEmpty } from "lodash";
import moment from "moment";

const ALL_PRODUCT_OPTION = {
  id: "ALL",
  product_code: "ALL",
};

const Dashboard = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const stores = useSelector(selectStores);
  const stockTypes = useSelector(selectStockTypes);
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  const DEFAULT_DATE_RANGE = [
    moment().subtract(7, "days").startOf("day"),
    moment().endOf("day"),
  ];

  const [isChartLayout, setIsChartLayout] = useState(true);
  const [store, setStore] = useState(null);
  const [product, setProduct] = useState(ALL_PRODUCT_OPTION);
  const [refetchVolume, setRefetchVolume] = useState(0);
  const [dateRangeForTableLayout, setDateRangeForTableLayout] =
    useState(DEFAULT_DATE_RANGE);
  const [openSalesModal, setOpenSalesModal] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");

  useEffect(() => {
    if (!isEmpty(stores)) {
      setStore(stores[0]);
    }
  }, [stores]);

  const onSalesSuccess = () => {
    setRefetchVolume(refetchVolume + 1);
    setSnackMessage(t("dashboard_screen.sales_success"));
  };

  return (
    <div>
      <Box
        display={"flex"}
        flexDirection={isDesktop ? "row" : "column"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box display={"flex"}>
          <span className={classes.regionalText}>
            {t("dashboard_screen.dashboard")}
          </span>
          <Box ml={5}>
            <SwitchButtons
              isChart={isChartLayout}
              onSwitch={setIsChartLayout}
            />
          </Box>
          <Box ml={5}>
            <Button
              color="secondary"
              className={classes.addSalesButton}
              variant="text"
              onClick={() => setOpenSalesModal(true)}
            >
              {t("dashboard_screen.add_sales_data")}
            </Button>
          </Box>
        </Box>
        <Box display={"flex"}>
          {isChartLayout ? (
            <ProductPicker
              products={[ALL_PRODUCT_OPTION, ...(store?.products || [])]}
              product={product}
              onChange={setProduct}
            />
          ) : (
            <DateRangePicker
              dateRange={dateRangeForTableLayout}
              onChangeDateRange={setDateRangeForTableLayout}
            />
          )}

          <Box ml={6}>
            <StorePicker
              stores={stores}
              store={store}
              onChange={(value) => {
                setStore(value);
              }}
            />
          </Box>
        </Box>
      </Box>
      {!!store &&
        (isChartLayout ? (
          <ChartLayout
            store={store}
            product={product}
            refetchVolume={refetchVolume}
          />
        ) : (
          <TableLayout
            store={store}
            dateRange={dateRangeForTableLayout}
            refetchVolume={refetchVolume}
          />
        ))}

      {openSalesModal && (
        <AddSalesModal
          store={store}
          stockTypes={stockTypes}
          products={store.products}
          open={openSalesModal}
          onClose={() => setOpenSalesModal(false)}
          onUpdateSuccess={onSalesSuccess}
        />
      )}

      <CustomizedSnackbars
        open={!!snackMessage}
        onClose={() => setSnackMessage("")}
        type="success"
        message={snackMessage}
      />
    </div>
  );
};

export default Dashboard;
